import Vue from 'vue'

export const IDERP_ADMIN_FINANZAS = 28
export const IDERPS_DESBLOQUEO_EMERGENCIA = [1, 334, 568]

/** Rutas permitidas cuando hay pagos sin validar (aceptado = 0) desde 2026. */
export const RUTAS_PERMITIDAS_BLOQUEO_FINANZAS = [
  'CorteDiario',
  'ValidarPagos',
  'ValidarIngresos',
  'EstadoCuentasBanco',
  'EstadoCuentasBancoDetalles',
  'Home',
  'Login',
  'Perfil',
]

export const RUTA_DEFAULT_BLOQUEO_FINANZAS = 'ValidarPagos'

export const BLOQUEO_VALIDACION_FINANZAS_EVENT = 'rh-bloqueo-validacion-finanzas'

export const bloqueoValidacionFinanzasBus = new Vue()

let estadoActual = {
  pendientes: 0,
  desbloqueo_emergencia: false,
  bloqueado: false,
  cargado: false,
}

export function esUsuarioAdminFinanzas(iderp) {
  return Number(iderp) === IDERP_ADMIN_FINANZAS
}

export function puedeDesbloqueoEmergenciaFinanzas(iderp) {
  return IDERPS_DESBLOQUEO_EMERGENCIA.includes(Number(iderp))
}

export function getEstadoBloqueoValidacionFinanzas() {
  return Object.assign({}, estadoActual)
}

export function setEstadoBloqueoValidacionFinanzas(parcial) {
  estadoActual = Object.assign({}, estadoActual, parcial || {}, { cargado: true })
  bloqueoValidacionFinanzasBus.$emit(BLOQUEO_VALIDACION_FINANZAS_EVENT, getEstadoBloqueoValidacionFinanzas())
  return getEstadoBloqueoValidacionFinanzas()
}

export function estaBloqueadoValidacionFinanzas(iderp) {
  if (!esUsuarioAdminFinanzas(iderp)) return false
  return !!estadoActual.bloqueado
}

export function rutaPermitidaEnBloqueoFinanzas(routeName) {
  if (!routeName) return false
  return RUTAS_PERMITIDAS_BLOQUEO_FINANZAS.includes(routeName)
}

function filtrarItemsPermitidos(items) {
  if (!Array.isArray(items)) return []

  const resultado = []
  for (const item of items) {
    if (!item) continue

    if (Array.isArray(item.items) && item.items.length) {
      const anidados = filtrarItemsPermitidos(item.items)
      if (anidados.length) {
        resultado.push(Object.assign({}, item, { items: anidados }))
      }
      continue
    }

    if (item.path && RUTAS_PERMITIDAS_BLOQUEO_FINANZAS.includes(item.path)) {
      resultado.push(item)
    }
  }
  return resultado
}

/**
 * Deja solo las vistas de validación de pagos/ingresos cuando el usuario 28 está bloqueado.
 */
export function filtrarMenuBloqueoValidacionFinanzas(menu, iderp, bloqueado) {
  if (!esUsuarioAdminFinanzas(iderp) || !bloqueado) {
    return Array.isArray(menu) ? menu : []
  }

  const list = Array.isArray(menu) ? menu : []
  return list
    .map((top) => {
      const items = filtrarItemsPermitidos(top.items || [])
      if (top.path && RUTAS_PERMITIDAS_BLOQUEO_FINANZAS.includes(top.path)) {
        return Object.assign({}, top, { items })
      }
      return Object.assign({}, top, { items })
    })
    .filter((top) => {
      if (top.path && RUTAS_PERMITIDAS_BLOQUEO_FINANZAS.includes(top.path)) return true
      return Array.isArray(top.items) && top.items.length > 0
    })
}
